export const BASE_URL = process.env.BASE_URL
export const API_URL  = "https://api.commergnat.com/"
